import React, { createContext, useContext, useState, useEffect } from 'react';
import { BRAND_LOGO } from '../constants/brand';

const ThemeContext = createContext();

function syncFavicon(isDark) {
  const link =
    document.querySelector('link[rel="icon"]') ??
    (() => {
      const el = document.createElement('link');
      el.rel = 'icon';
      el.type = 'image/svg+xml';
      document.head.appendChild(el);
      return el;
    })();
  link.href = isDark ? BRAND_LOGO.dark : BRAND_LOGO.light;
}

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('gfi-theme');
    return saved === 'dark';
  });

  useEffect(() => {
    const root = window.document.documentElement;
    if (isDark) {
      root.setAttribute('data-theme', 'dark');
      localStorage.setItem('gfi-theme', 'dark');
    } else {
      root.removeAttribute('data-theme');
      localStorage.setItem('gfi-theme', 'light');
    }
    syncFavicon(isDark);
  }, [isDark]);

  const toggleTheme = () => setIsDark(!isDark);

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);